import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, parseISO } from 'date-fns';

const UtilityAnalytics = ({ bills, type = 'Electricity' }) => {
  const filteredBills = bills
    .filter(b => b.type === type)
    .sort((a, b) => new Date(a.billingMonth) - new Date(b.billingMonth));

  const labels = filteredBills.map(b => format(parseISO(b.billingMonth + '-01'), 'MMM yy'));
  const costs = filteredBills.map(b => b.amount);
  const usage = filteredBills.map(b => b.usageValue);

  const option = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
    legend: { bottom: 0, textStyle: { fontSize: 10, fontWeight: 'bold' }, icon: 'circle' },
    grid: { left: '3%', right: '4%', top: '10%', bottom: '15%', containLabel: true },
    xAxis: { type: 'category', data: labels, axisLine: { show: false } },
    yAxis: [
      { type: 'value', name: 'Cost ($)', axisLabel: { formatter: '${value}' }, splitLine: { lineStyle: { type: 'dashed' } } },
      { type: 'value', name: 'Usage', splitLine: { show: false } }
    ],
    series: [
      {
        name: 'Billing Amount',
        type: 'bar',
        data: costs,
        itemStyle: { color: '#4F46E5', borderRadius: [4, 4, 0, 0] },
        barWidth: '30%'
      },
      {
        name: 'Usage Value',
        type: 'line',
        yAxisIndex: 1,
        data: usage,
        smooth: true,
        lineStyle: { width: 3, color: '#F59E0B' },
        itemStyle: { color: '#F59E0B' }
      }
    ]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm h-full flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest">{type} Consumption Trend</h3>
        <span className="text-[10px] font-black text-indigo-600 bg-indigo-50 px-2 py-1 rounded">Last 12 Months</span>
      </div>
      <div className="flex-1 min-h-[300px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default UtilityAnalytics;